module.exports = __webpack_public_path__ + "img/placeholder/articles/article-7.jpg";